import GenericErrorCodes from "../../../errorCodes/Generic"

type ErrData = PBError["errorData"]
/**
 * Error handlers map errorCodes from BE services to a phrase key
 *
 * A handler should return a single string, expected to be a string
 * Alternatively a tuple of phraseKey and errorData can be returned, this allows data to be manipulated before passing to phrase FormatMessage
 */
export type ErrorHandlerCallback = (errorCode: string, error: PBError) => string | [string, ErrData]

const handlers: ErrorHandlerCallback[] = [genericErrorHandler]

class ErrorHandlerRegister {
  add(handler: ErrorHandlerCallback) {
    // make sure we don't add the same handler more than once
    if (!handlers.includes(handler) && typeof handler === "function") {
      handlers.push(handler)
    }
  }

  remove() {
    throw new Error("[ErrorHandlerRegister]: Not yet implemented.")
  }

  getMessage(errorCode: string, error: PBError | GraphError): string {
    for (const handler of handlers) {
      const msg = handler(errorCode, error)
      if (Array.isArray(msg)) {
        return msg[0]
      } else if (msg) {
        return msg
      }
    }

    return "errors.unknownError"
  }

  getErrorData(errorCode: string, error: PBError): ErrData {
    for (const handler of handlers) {
      const mappedErrorData = handler(errorCode, error)
      if (Array.isArray(mappedErrorData) && mappedErrorData[1]) {
        return mappedErrorData[1]
      }
    }

    return (
      error.errorData || // already assigned
      error.response?.data.data || // REST API response
      (error as any).data || // simple assign
      {}
    )
  }
}

export default new ErrorHandlerRegister()

function genericErrorHandler(errCode: string) {
  switch (errCode) {
    case "PBErrGraphqlError":
      return "errors.PBErrGraphqlError"
    case GenericErrorCodes.PBERRForbiddenNoPermission:
    case GenericErrorCodes.PBERRForbiddenRestrictionCheckFailed:
      return "errors.PBERRForbiddenNoPermission"
    case GenericErrorCodes.PBERRForbiddenInvalidToken:
    case GenericErrorCodes.PBERRTokenMissing:
      return "errors.PBERRForbiddenInvalidToken"
    default:
      return ""
  }
}
